module.exports = __webpack_public_path__ + "static/research-5794dd624be3e0f4f8edde23209da2db.png";